"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const web_core_1 = require("@qlean/web-core");
function getDatasetName(appId) {
    const words = appId.split('-');
    return words.reduce((name, word) => {
        const [firstLetter, ...restWord] = word;
        return `${name}${firstLetter.toUpperCase()}${restWord.join('')}`;
    });
}
function hydrateApp(appId, App) {
    const nodes = document.querySelectorAll(`[data-${appId}]`);
    nodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) {
            return;
        }
        const datasetName = getDatasetName(appId);
        const propJson = node.dataset[datasetName];
        const props = JSON.parse(propJson);
        new App({
            target: node,
            hydrate: true,
            props,
        });
    });
}
exports.hydrateApp = hydrateApp;
function afterMount() {
    web_core_1.Bus.emit(web_core_1.WIDGET_MOUNTED);
}
exports.afterMount = afterMount;
